// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"BufferingWheel_Spinner__z0w1t","Container":"BufferingWheel_Container__DRq7N","anim-spin":"BufferingWheel_anim-spin__zhxwd","Text":"BufferingWheel_Text__9cOA6"};